/**
 * Legislation-only pieces on top of the shared primitives (components/shared/ui.tsx, screenshots/00):
 * the card kicker ("COUNCIL FORECAST · OCT 14"), the AI chip, Link / Arrow with a Lucide arrow, and the
 * dropdown button the Roll calls filters use ("All 27 categories ⌄").
 */
import type { ReactNode } from "react";
import { ArrowRight, ChevronDown, Sparkles } from "lucide-react";
import { Dropdown } from "../components/shared/Dropdown";

export { CountBadge, GroupLabel, SectionHeader, TabBar, ViewSwitch } from "../components/shared/ui";

export const Kicker = ({ children }: { children: ReactNode }) => <span className="eyebrow lg-kicker">{children}</span>;

export const AiChip = ({ children }: { children: ReactNode }) => <span className="ai-chip"><Sparkles size={11} aria-hidden />{children}</span>;

export function LinkArrow({ href, onClick, children, muted, icon }: { href?: string; onClick?: () => void; children: ReactNode; muted?: boolean; icon?: ReactNode }) {
  const inner = <>{children}{icon ?? <ArrowRight size={14} aria-hidden />}</>;
  const cls = muted ? "link-arrow lg-link--muted" : "link-arrow";
  return href ? <a className={cls} href={href} onClick={onClick}>{inner}</a> : <button className={cls} onClick={onClick}>{inner}</button>;
}

/** A filter button that opens the shared Dropdown list. */
export function SelectButton<T extends string>({ icon, value, options, onChange, label }: {
  icon: ReactNode; value: T; options: readonly { id: T; label: string }[]; onChange: (v: T) => void; label: string;
}) {
  const current = options.find((o) => o.id === value) ?? options[0];
  return (
    <Dropdown className="btn lg-select" label={label} icon={icon} value={value} onChange={onChange} display={current?.label}
      options={options.map((o) => ({ value: o.id, label: o.label }))} chevron={<ChevronDown size={14} aria-hidden />} />
  );
}
